type DocumentationPermissionSource = {
  allowDownload?: boolean | null;
  allowPrint?: boolean | null;
  category?: {
    allowDownload?: boolean | null;
    allowPrint?: boolean | null;
  } | null;
};

// `Documentation.allowDownload`/`allowPrint` are nullable: null means "follow
// the category's default", so a document with no explicit override tracks
// future changes to its category. No category (or no document at all) falls
// back to `false` — restrictive by default, mirroring the admin form's
// defaults (see DocumentForm/utils/getDefaultValuesFromQueryData.ts).
export default function getDocumentationFilePermissions(
  documentation: DocumentationPermissionSource | null | undefined,
) {
  return {
    allowDownload:
      documentation?.allowDownload ??
      documentation?.category?.allowDownload ??
      false,
    allowPrint:
      documentation?.allowPrint ?? documentation?.category?.allowPrint ?? false,
  };
}
